import React from 'react';
import { UiGrid, UiButton, UiText } from '@open-stack/ui';
import { Outlet } from '../../../XV2';
import styled from 'styled-components';
import { RootIdPage } from '../../../pages/id/RootIdPage';
import { useRouter } from '../../../hooks/router';
import { Zone } from '../../../XV2';

const Wrapper = styled(UiGrid)`
    .image-container {
        height: 200px;
        position: relative;
    }
`;

interface Props {
    outlet: Pick<Outlet, 'id' | 'name'> & {
        zones: Pick<Zone, 'id' | 'name'>[];
    };
}

export function TagOutlet({ outlet }: Props) {
    const { replaceParams } = useRouter();

    return (
        <Wrapper padding={4} gap={4}>
            <UiText fontSize={4}>{outlet.name}</UiText>

            <UiGrid minMax={100}>
                {outlet.zones.map((zone) => (
                    <UiButton to={replaceParams(RootIdPage.route, { id: zone.id })} fullWidth>
                        {zone.name}
                    </UiButton>
                ))}
            </UiGrid>
        </Wrapper>
    );
}
